import { MapPin, Phone, Mail, Building2, TrendingUp } from 'lucide-react';

const Branches = () => {
    return (
        <section id="branches" className="py-16 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Head Office & Branches</h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        We are committed to expanding our reach across semi-urban and rural areas
                    </p>
                </div>

                <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
                    <div className="bg-gradient-to-br from-amber-50 to-amber-50 rounded-xl p-8 shadow-lg border border-amber-200">
                        <div className="flex items-center mb-6">
                            <div className="w-12 h-12 bg-amber-900 rounded-full flex items-center justify-center text-white mr-4">
                                <Building2 className="w-6 h-6" />
                            </div>
                            <h3 className="text-2xl font-bold text-gray-900">Head Office</h3>
                        </div>

                        <div className="space-y-4">
                            <div className="flex items-start">
                                <MapPin className="w-5 h-5 text-abmer-900 mr-3 flex-shrink-0 mt-1" />
                                <div>
                                    <p className="font-semibold text-gray-900 text-sm">Address:</p>
                                    <p className="text-gray-700 text-sm">
                                        Ward No 27<br />
                                        Sagwara<br />
                                        Dungarpur, Rajasthan - 314025
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <Phone className="w-5 h-5 text-amber-900 mr-3 flex-shrink-0 mt-1" />
                                <div>
                                    <p className="font-semibold text-gray-900 text-sm">Phone:</p>
                                    <p className="text-gray-700 text-sm">99414567638</p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <Mail className="w-5 h-5 text-amber-900 mr-3 flex-shrink-0 mt-1" />
                                <div>
                                    <p className="font-semibold text-gray-900 text-sm">Email:</p>
                                    <p className="text-gray-700 text-sm">sagwaranidhilimited@gmail.com</p>
                                </div>
                            </div>
                        </div>

                        <div className="mt-6 pt-6 border-t border-amber-200">
                            <p className="text-xs text-gray-600 italic">
                                Open Monday to Saturday: 10:00 AM - 5:00 PM<br />
                                Closed on Sundays and public holidays
                            </p>
                        </div>
                    </div>

                    <div className="bg-amber-50 rounded-xl p-8 shadow-lg border border-amber-200">
                        <div className="flex items-center mb-6">
                            <div className="w-12 h-12 bg-amber-900 rounded-full flex items-center justify-center text-white mr-4">
                                <TrendingUp className="w-6 h-6" />
                            </div>
                            <h3 className="text-2xl font-bold text-gray-900">Expansion Strategy</h3>
                        </div>

                        <div className="space-y-4">
                            <p className="text-gray-700 text-sm leading-relaxed">
                                Sagwara Apni Bachat Ghar Mahila Sahakari Samiti Limited is actively expanding its presence to serve more communities across India. Our expansion focuses on:
                            </p>

                            <ul className="space-y-3">
                                <li className="flex items-start">
                                    <span className="text-amber-900 mr-2 font-bold text-lg">•</span>
                                    <div>
                                        <p className="font-semibold text-gray-900 text-sm">Semi-Urban Areas</p>
                                        <p className="text-xs text-gray-600">Bringing financial services to tier 2 and tier 3 cities</p>
                                    </div>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-amber-900 mr-2 font-bold text-lg">•</span>
                                    <div>
                                        <p className="font-semibold text-gray-900 text-sm">Rural Communities</p>
                                        <p className="text-xs text-gray-600">Enhancing financial inclusion in underserved villages</p>
                                    </div>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-amber-900 mr-2 font-bold text-lg">•</span>
                                    <div>
                                        <p className="font-semibold text-gray-900 text-sm">Strategic Partnerships</p>
                                        <p className="text-xs text-gray-600">Collaborating with local organizations for wider reach</p>
                                    </div>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-amber-900 mr-2 font-bold text-lg">•</span>
                                    <div>
                                        <p className="font-semibold text-gray-900 text-sm">Digital Services</p>
                                        <p className="text-xs text-gray-600">Leveraging technology for convenient access</p>
                                    </div>
                                </li>
                            </ul>

                            <div className="mt-6 pt-6 border-t border-amber-200">
                                <p className="text-xs text-gray-600 italic">
                                    New branches coming soon. Stay connected for updates on locations near you.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Branches;
